import React from "react";
import { useExpansionListShortened } from "hooks";
import { ProductShortened } from "types";
import {
  CustomReactTableHandles,
  CustomTable,
  Loading,
  SortableHeader,
} from "core";
import { getExpansionName } from "modules/expansions/business";
import useStyles from "./styles";

type ProductToBuyListTableProps = {
  isLoading: boolean;
  productList: ProductShortened[];
  productTableRef?: React.RefObject<CustomReactTableHandles<ProductShortened>>;
};

export const ProductToBuyListTable: React.FC<ProductToBuyListTableProps> = ({
  isLoading,
  productList,
}) => {
  const { classes } = useStyles();

  const { expansionList } = useExpansionListShortened(false);

  console.log("productList", productList);
  console.log("expansionList", expansionList);

  return (
    <>
      <CustomTable
        marginBottom={0}
        uppercaseHeaders={false}
        fixedLayout={productList.length !== 0}
        stickyOffset={0}
      >
        <colgroup>
          <col width="15px" />
          <col width="100px" />
          <col width="100px" />
          <col width="100px" />
        </colgroup>

        <thead>
          <tr>
            <SortableHeader
              headerID="rarity"
              header="R"
              dataLength={productList.length}
              isLoadingDataList={isLoading}
            />
            <SortableHeader
              headerID="productDeName"
              header="Deutsch"
              isDefaultSort={true}
              defaultSortOrder="asc"
              dataLength={productList.length}
              isLoadingDataList={isLoading}
            />
            <SortableHeader
              headerID="productEnName"
              header="English"
              dataLength={productList.length}
              isLoadingDataList={isLoading}
            />
            <SortableHeader
              headerID="expansionID"
              header="Erweiterung"
              dataLength={productList.length}
              isLoadingDataList={isLoading}
            />
          </tr>
        </thead>
        <tbody>
          {productList.length === 0 ? (
            <tr>
              <td colSpan={99}>
                <div className={classes.noResults}>
                  {isLoading ? (
                    <Loading
                      size="25px"
                      description="Bitte warten. Karten werden geladen..."
                      style={{ margin: 0 }}
                    />
                  ) : (
                    "Keine Karten gefunden"
                  )}
                </div>
              </td>
            </tr>
          ) : (
            productList.map((product) => {
              const expansion = expansionList.find(
                (expansion) => expansion.id === product.expansionID,
              );

              if (!expansion) {
                return null;
              }

              return (
                <tr key={product.id} className={classes.productItem}>
                  <td width="15px">{product.rarity.charAt(0)}</td>
                  <td width="200px" className={classes.noWrap}>
                    <div className={classes.productName}>
                      {product.productAlias ?? product.productDeName}
                    </div>
                  </td>
                  <td width="200px" className={classes.noWrap}>
                    <div className={classes.productName}>
                      {product.productEnName}
                    </div>
                  </td>
                  <td width="200px" className={classes.noWrap}>
                    <div className={classes.productName}>
                      {getExpansionName(expansion)}
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </CustomTable>
    </>
  );
};
